import React from "react";

import style from './TextAddStable.module.css';

const TextAddStable = (props) => {

    return (
        <div className={style.body}>
            {props.title ?
                props.url ?
                    <a href={props.url}>{props.text}</a> :
                    <span>{props.text}</span>

            :
                <h4>{props.text}</h4>
            }
        </div>
    )
};

export default TextAddStable;